import { EBloodType } from '@/src/shared/enums/blood-type';
import { EIdCardVerification } from '@/src/shared/enums/id-card-verification';
import { EMaritalStatus } from '@/src/shared/enums/marital-status';
import { EReligion } from '@/src/shared/enums/religion';
import { EGender } from '../../../shared/enums/gender';

export interface IIndividual {
  id: number;
  profileImage: string | null;
  idCardImage: string | null;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  nik: string | null;
  nickname: string;
  birthplace: string | null;
  bpjsHealth: string | null;
  bpjsEmployment: string | null;
  citizenship: string | null;
  is_active: boolean;
  identityAddress: string | null;
  province: string | null;
  city: string | null;
  subdistrict: string | null;
  village: string | null;
  provinceCode: string | null;
  cityCode: string | null;
  subdistrictCode: string | null;
  villageCode: string | null;
  rt: string | null;
  rw: string | null;

  gender: EGender;
  birthDate: Date;
  idCardVerification: EIdCardVerification | null;
  bloodType: EBloodType | null;
  religion: EReligion | null;
  maritalStatus: EMaritalStatus | null;
}

export class MIndividual {
  props: IIndividual;

  constructor(props: IIndividual) {
    this.props = props;
  }

  get fullName() {
    if (this.props.lastName.trim().length === 0) {
      return this.props.firstName;
    }
    return `${this.props.firstName} ${this.props.lastName}`;
  }
}
